
    <div class="row pt-3 p-5">
        <div class="col-md-12  overflow-auto mb-5 ct_custom_flex_basisc"
            [ngClass]="this.updatedtheme === 'dark' ? 'User-tabD' : 'User-tabL'">
            <div class="row">
                <div class="" [ngClass]="
                        this.updatedtheme === 'dark'
                            ? 'User-headD'
                            : 'User-headL'
                    ">
                    <div
                        class="card-header card-headerL ct_header_grey_1202 d-flex align-items-center justify-content-between">
                        <h4 class=" ct_fw_600 m-0 my-0" style="flex: 1;">Cost Centre</h4>
                        <button class="GroupButton ct_assign_package_btn129 ct_animation_btn_121 w-auto px-3"
                            (click)="showAddGroupDialog('2')">
                            + Add Cost Centre
                        </button>
                    </div>
                </div>

            </div>

            <p-toast></p-toast>
            <p-confirmDialog #cd [style]="{width: '60vw'}">
                <ng-template pTemplate="footer">
                    <button pButton icon="pi pi-check" label="Yes" (click)="cd.accept()"
                        class="span-color cancel-button"></button>
                    <button pButton icon="pi pi-times" label="Cancel" (click)="cd.reject()"
                        class="p-button-raised p-button-danger"></button>
                </ng-template>
            </p-confirmDialog>





            <div class="dataTable scrollit mt-4">
                <table class="table_loc ct_space_table_21 ct_billing_table_bg_120">
                    <thead>
                        <tr>

                            <th scope="col" style="width: 400px; font-size: 16px;">S.No.</th>
                            <th scope="col" style="width: 400px;font-size: 16px;"> Cost Centre Name </th>
                            <th scope="col" style="font-size: 16px;">Reference ID</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr clickable (click)="selectGroup(group,index)" *ngFor="
                                let group of CostList;let index = index
                            " class="col-12 tableRow border-bottom rounded pointer"
                            (click)="UnlockComplete(group.id)"
                            [ngClass]="{ 'tableRowclicked': index === selectedRowIndex }">
                            <td class="td text-initial" style="width: 300px; font-size: 16px;">
                                {{ index + 1 }}
                            </td>
                            <td class="td " style="width: 400px; font-size: 16px;">
                                {{ group.cost_center_name }}

                            </td>
                            <td class="td  pb-1" style="font-size: 16px;">
                                {{ group.cost_center_refer_id }}

                            </td>


                        </tr>
                    </tbody>
                </table>
                <div class="text-light" *ngIf="groupdata === false">
                    <div class="icon">
                        <i class="fa fa-info-circle" style="font-size: 20px" aria-hidden="true"></i>
                    </div>
                    <label class="text-center label">No group available. Start by add a new group using the
                        add group button.</label>
                </div>
            </div>
        </div>


    </div>



<p-dialog  [(visible)]="visible2" [breakpoints]="{'960px': '75vw'}" [style]="{width: '50vw'}">
    <p-header *ngIf="FormEdit === false"> Add Cost Centre </p-header>
    <p-header *ngIf="FormEdit === true"> Edit Target </p-header>

    <div class="modal-body text-white text-style Dashboard-tab ct_vertically_scroll">
        <form #GroupCostForm="ngForm" class="col-12" (ngSubmit)="
            FormEdit === false
                ? saveCostCentre(GroupCostForm)
                : updateGroup(GroupCostForm.value)
        ">
            <div class="mb-5 pb-0 row">
                <div class="col-md-6 mb-3">
                    <label for="fname"> Cost centre name</label>
                    <input name="cost_center_name" ngModel id="search-input" type="text"
                        class="form-control Dashboard-tab text-white" placeholder="Enter Name" #groupName="ngModel"
                        [disabled]="isloading" required />
                    <p class="text-danger mb-0" *ngIf="GroupCostForm.submitted && groupName.errors?.['required']">
                        Name is required
                    </p>
                    <!-- <p class="text-danger mb-0" *ngIf="
                    isgroupExist === true && groupName.touched
                ">
                        group already exist please use other groupname
                    </p> -->
                </div>
                <div class="col-md-6 mb-3">
                    <label for="fname">Reference Id </label>
                    <input ngModel id="search-input" type="text" class="form-control Dashboard-tab text-white "
                        name="cost_center_refer_id" placeholder="Enter address" #groupName="ngModel"
                        [disabled]="isloading" required>
                    <!-- <p class="text-danger mb-0" *ngIf="GroupForm.submitted && groupName.errors?.['required']">
                        Group name is required
                    </p> -->
                    <!-- <p class="text-danger mb-0" *ngIf="
                    isgroupExist === true && groupName.touched
                ">
                        group already exist please use other groupname
                    </p> -->
                </div>




            </div>
            <div style="height: 80px;"></div>

            <div class="mt-3 ct_modal_btns_12">
                <Button  type="submit" *ngIf="FormEdit === false" [disabled]="
                    (this.selectedRole !== Roleaccess &&
                        facilitydata === true) ||
                    usernameIsExist === true ||
                    emailIstExist === true
                " class="rounded span-color px-3 text-white text-style loading ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Save
                </Button>
                <Button *ngIf="FormEdit === true" type="submit " class="rounded span-color px-3 text-white text-style ">
                    <p-progressSpinner strokeWidth="8" *ngIf="isloading === true"></p-progressSpinner>
                    Update
                </Button>

                <span type="button" class="text-white font-weight-light ml-3 "
                    (click)="onCloseHandled()">
                    Close
                </span>
            </div>
        </form>
    </div>
</p-dialog>